import { createSelector } from "reselect";
//EXTRACT THE PART OF THE STATE
const getData = state => state.messaging.lastResult;

const getConversationsLastResult = createSelector(
  getData,
  lastResult => lastResult
);

export default getConversationsLastResult;



// WEBPACK FOOTER //
// ./src/_selectors/messagingSelectors/getConversationsLastResult.js